// Overlap-resolution modal.
//
// Injected into #overlap_modal via Turbo Stream when a timer start or stop
// would overlap an existing entry. Opens itself on connect; cancel or a
// backdrop click closes the dialog and removes the injected markup so the
// container is clean for next time.
//
// The remedy choices inside are plain forms that re-POST — Turbo carries
// those, and a successful action redirects, so no JS is needed for them.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["dialog"]
  declare readonly dialogTarget: HTMLDialogElement

  connect(): void {
    if (typeof this.dialogTarget.showModal === "function") {
      if (!this.dialogTarget.open) this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "")
    }
  }

  cancel(): void {
    this.close()
  }

  // A click that lands on the <dialog> itself (not its card child) is the
  // backdrop — dismiss.
  backdropClick(event: MouseEvent): void {
    if (event.target === this.dialogTarget) this.close()
  }

  private close(): void {
    if (typeof this.dialogTarget.close === "function") this.dialogTarget.close()
    this.element.remove()
  }
}
